module.exports = __webpack_public_path__ + "loginBackground.jpg";